import PaymentDetailsForm from './PaymentDetailsForm';

export default PaymentDetailsForm;
